import { Injectable } from '@angular/core';

import { HttpService, TmsWebBaseCommentService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderCommentService extends TmsWebBaseCommentService {
  constructor(protected httpService: HttpService) {
    super('PurchaseOrderComment', httpService);
  }
}
